import EditorField from 'builder/components/EditorField'
import { TextField } from 'builder/components/TextField'
import { useWorkExperienceCardContext } from '../../ExpandableCardContext'
import { useShokumuTranslations } from '../../useShokumuTranslations'

const Sales = (): JSX.Element => {
  const {
    item: { employerProfilesAttributes },
    onCardValueChange,
  } = useWorkExperienceCardContext()

  const { i18n } = useShokumuTranslations()
  const label = i18n('work_experience.employer_details.sales')

  const updateSales = (e: React.ChangeEvent<HTMLInputElement>) => {
    onCardValueChange(
      { employerProfilesAttributes: { ...employerProfilesAttributes, sales: e.target.value } },
      true,
    )
  }

  return (
    <EditorField>
      <TextField
        label={label}
        name="sales"
        onChange={updateSales}
        value={employerProfilesAttributes?.sales || ''}
      />
    </EditorField>
  )
}
export default Sales
